import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import type { UserRole } from '../types';

interface Props {
  roles: UserRole[];
}

export default function ProtectedRoute({ roles }: Props) {
  const { appUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-600 border-t-transparent" />
      </div>
    );
  }

  // Remember where they were headed. Transactional emails deep-link into pages
  // like /leave/approvals; without this, an approver who is signed out lands on
  // Home and has to find the request themselves.
  if (!appUser) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (!roles.includes(appUser.role)) return <Navigate to="/" replace />;

  return <Outlet />;
}
